'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccentText } from '@lichtblick/photon/atoms/accent-text/accent-text';
import { AccordionHeader, AccordionTrigger } from '@lichtblick/photon/organisms/accordion/accordion';
import { RichText } from '../../helpers/RichText';
import { CollapsibleContent, HeaderContent, Icon, IconWrapper, Root, StyledContent } from './MAccordionItem.styles';
export const MAccordionItem = ({ isThemeFadedGray, text, title })=>/*#__PURE__*/ _jsxs(Root, {
        $isThemeFadedGray: isThemeFadedGray ?? false,
        "data-testid": "accordion-item",
        value: title ?? '',
        children: [
            /*#__PURE__*/ _jsx(AccordionHeader, {
                asChild: true,
                children: /*#__PURE__*/ _jsx(AccordionTrigger, {
                    children: /*#__PURE__*/ _jsxs(HeaderContent, {
                        children: [
                            /*#__PURE__*/ _jsx(IconWrapper, {
                                children: /*#__PURE__*/ _jsx(Icon, {})
                            }),
                            /*#__PURE__*/ _jsx(AccentText, {
                                children: title
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(StyledContent, {
                children: /*#__PURE__*/ _jsx(CollapsibleContent, {
                    children: /*#__PURE__*/ _jsx(RichText, {
                        richText: text
                    })
                })
            })
        ]
    });

//# sourceMappingURL=MAccordionItem.js.map